import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Box = styled.div`
  margin-top: 12px;

  .item > div {
    display: block;
    overflow: hidden;
    width: 100%;
    height: auto;
    padding-bottom: 133.34%;
    background-color: #f6f6f6;
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('12')};
  }
`;
